<template>
    <DataTable v-if='pays' :value="pays" responsiveLayout="scroll" ref="dt" dataKey="id"
        :rows="100" :rowsPerPageOptions="[5, 10, 20, 50, 100]" :totalRecords="totalRecords"
        @page="onPage($event)" @sort="onSort($event)" :loading="loading" 
        @filter="onFilter($event)" v-model:filters="filters" filterDisplay="menu" :globalFilterFields="['type']" >

        <Column field="active" header="">
            <template #header>
                <span class="text-xs">Акт.</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center">
                    <span class="text-white font-medium text-xs p-1 border-round-md" :class="(data.active) ? 'surface-500' : 'bg-orange-400'">
                        {{ (data.active) ? 'да' : 'нет' }}
                    </span>
                    <Button icon="pi pi-pencil" @click="edit(data)" class="flex border-round-lg border-none" size="small" severity="info"/>
                </div>
            </template>
        </Column>

        <Column field="code" header="">
            <template #header>
                <span class="text-xs">Имя/код</span>
            </template>
            <template #body="{ data }">
                <div v-if="data.code" class="flex flex-row text-sm m-0">
                    <img :src="get_image(data)" class="mr-3" style="max-width: 22px;">
                    <div class="flex flex-column gap-1">
                        <span class="flex white-space-nowrap" >{{ get_title(data) }} ({{data.code}})</span>
                        <span class="flex text-500 text-xs" >{{ getDescription(data) }} ({{data.code}})</span>
                    </div>
                </div>
            </template>
        </Column>

        <Column field="direction" :showFilterMenu="true" :showFilterMatchModes="false" >
            <template #header>
                <span class="text-xs">Напр.</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Select v-model="filterModel.value" @change="filterCallback()" :options="directions" optionLabel="label" optionValue="value" placeholder="Все" class="p-column-filter" :showClear="true">
                    <template #option="slotProps">
                        <div class="inline-block py-1 px-2 text-xs border-round-md font-semibold surface-300 cursor-pointer font-medium align-items-center">
                            <span class="flex">{{ slotProps.option.label }}</span>
                        </div>
                    </template>
                </Select>
            </template>
            <template #body="{ data }">
                <span class="text-sm">
                    {{ (data.direction && data.direction=='get') ? 'Прием' : '' }}
                    {{ (data.direction && data.direction=='send') ? 'Отправка' : '' }}
                    {{ (data.direction && data.direction=='both') ? 'Прием/Отправка' : '' }}
                </span>
            </template>
        </Column>

        <Column field="currency_code" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
                <span class="text-xs">Валюта</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Select v-model="filterModel.value" @change="filterCallback()" :options="currencies" optionLabel="code" optionValue="code" placeholder="Все" class="p-column-filter" :showClear="true" filter>
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <img v-if="slotProps.option.code" :src="getCurImage(slotProps.option.code)" class="mr-2 w-3 border-200 border-1 border-circle" style="max-width: 22px;" />
                            <span class="flex uppercase ml-2">{{ slotProps.option.code }}</span>
                        </div>
                    </template>
                </Select>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-2" >
                    <AvatarGroup v-if="data.currency_code">
                        <Avatar :image="getCurImage(data.currency_code)" class="surface-0  border-2 border-100" shape="circle" size="small"/>
                    </AvatarGroup>
                    <p class="text-xs white-space-nowrap m-0 uppercase">
                        {{ (data.currency_code) ? data.currency_code : '–'}}
                    </p>
                </div>
            </template>
        </Column>

        <Column field="type" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
                <span class="text-xs">Тип</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Select v-model="filterModel.value" @change="filterCallback()" :options="types" placeholder="Все" class="p-column-filter" :showClear="true">
                    <template #option="slotProps">
                        <div class="inline-block py-1 px-2 text-xs border-round-md font-semibold surface-300 cursor-pointer font-medium align-items-center" >
                            <span class="flex">{{slotProps.option}}</span>
                        </div>
                    </template>
                </Select>
            </template>
            <template #body="{ data }">
                <span class="text-sm">
                    {{ getDataType(data) }}
                </span>
            </template>
        </Column>

        <Column field="sort" header="">
            <template #header>
                <span class="text-xs">Сорт.</span>
            </template>
            <template #body="{ data }">
                <p v-if="data.sort" class="text-xs white-space-nowrap m-0">
                    {{ data.sort }}
                </p>
            </template>
        </Column>

        <Column field="active_from" header="">
            <template #header>
                <span class="text-xs">Расписание</span>
            </template>
            <template #body="{ data }">
                <p v-if="hasSchedule(data)" class="text-xs white-space-nowrap m-0">
                    {{ getScheduleLabel(data) }}
                </p>
                <p v-else class="text-xs white-space-nowrap m-0 text-500">
                    -
                </p>
            </template>
        </Column>

        <Column field="comissions" header="">
            <template #header>
                <span class="text-xs">Комиссии</span>
            </template>
            <template #body="{ data }">
                <p v-if="data.comissions && (data.comissions.percent!=undefined)" class="text-xs white-space-nowrap m-0">
                    Процент – {{ data.comissions.percent }}
                </p>
                <p v-if="data.comissions && (data.comissions.fix!=undefined)" class="text-xs white-space-nowrap m-0">
                    Фикс – {{ data.comissions.fix }} USDT
                </p>
            </template>
        </Column>

        <Column field="limits" header="">
            <template #header>
                <span class="text-xs">Лимиты</span>
            </template>
            <template #body="{ data }">
                <p v-if="data.limits && (data.limits.min!=undefined)" class="text-xs white-space-nowrap m-0">
                    Min – {{ data.limits.min }}
                </p>
                <p v-if="data.limits && (data.limits.max!=undefined)" class="text-xs white-space-nowrap m-0">
                    Max – {{ data.limits.max }}
                </p>
            </template>
        </Column>
    </DataTable>


    <!--ИЗМЕНЕНИЕ-->
    <Dialog class="flex flex-column border-none" modal
        v-model:visible="editPopup"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Редактировать платежную систему <span v-if="currentPaySys.code">{{ currentPaySys.code }}</span></span>
            </div>
        </template>
        
        <div class="flex flex-column w-full gap-3">
            <div class="flex flex-column xl:flex-row lg:flex-row w-full gap-3">
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Тип <span class="text-red-500">*</span>: </span>
                    <Select v-model="currentPaySys.type" :options="types" placeholder="Тип" class="flex" />
                </div>
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Направление <span class="text-red-500">*</span>: </span>
                    <Select v-model="currentPaySys.direction" :options="directions" optionLabel="label" optionValue="value" placeholder="Направление" class="flex" />
                </div>
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Код <span class="text-red-500">*</span>: </span>
                    <InputText v-model="currentPaySys.code" class="flex" placeholder="example_code"/>
                </div>
            </div>

            <div class="flex flex-column xl:flex-row lg:flex-row w-full gap-3">
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Активность: </span>
                    <SelectButton v-model="currentPaySys.active" :options="active_list" optionLabel="name" optionValue="value" aria-labelledby="basic" />
                </div>
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Картинка <span class="text-red-500">*</span>: </span>
                    <InputText v-model="currentPaySys.image" class="flex" placeholder="/images/svg/pays/other.svg"/>
                </div>
            </div>

            <div class="flex flex-column xl:flex-row lg:flex-row w-full gap-3">
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Сортировка <span class="text-red-500">*</span>: </span>
                    <InputNumber v-model="currentPaySys.sort" class="flex"/>
                </div>
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Валюта <span class="text-red-500">*</span>: </span>
                    <Select v-model="currentPaySys.currency_code" :options="currencies" placeholder="Валюта" optionLabel="code" optionValue="code" :showClear="true" filter class="flex w-full">
                        <template #value="slotProps">
                            <div v-if="slotProps.value" class="flex align-items-center"> 
                                <img :src="getCurImage(slotProps.value)" class="mr-2 w-3 border-200 border-1 border-circle" style="max-width: 22px;" />
                                <span class="flex uppercase ml-2">{{slotProps.value}}</span>
                            </div>
                            <span v-else>
                                {{ slotProps.placeholder }}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <div class="flex align-items-center">
                                <img v-if="slotProps.option.code" :src="getCurImage(slotProps.option.code)" class="mr-2 w-3 border-200 border-1 border-circle" style="max-width: 22px;" />
                                <span class="flex uppercase ml-2">{{slotProps.option.code}}</span>
                            </div>
                        </template>
                    </Select>
                </div>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Название <span class="text-red-500">*</span>: </span>
                <InputText v-model="currentPaySys.titles.ru" class="flex" placeholder="Название на русском"/>
                <InputText v-model="currentPaySys.titles.en" class="flex" placeholder="Название на английском"/>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Описание: </span>
                <InputText v-model="currentPaySys.descriptions.ru" class="flex" placeholder="Описание на русском"/>
                <InputText v-model="currentPaySys.descriptions.en" class="flex" placeholder="Описание на английском"/>
            </div>

            <div class="flex w-full gap-2 flex-column xl:flex-row lg:flex-row">
                <div class="flex flex-column gap-2">
                    <span class="flex">Поля получателя: </span>
                    <MultiSelect v-model="currentPaySys.recipient_fields" :options="fields" placeholder="Выберите до 3 полей"
                        :maxSelectedLabels="3" class="w-full" />
                </div>

                <div class="flex flex-column gap-2">
                    <span class="flex">Обяз. поля получателя: </span>
                    <MultiSelect v-model="currentPaySys.recipient_fields_required" :options="fields" placeholder="Выберите до 3 полей"
                        :maxSelectedLabels="3" class="w-full" />
                </div>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Требуется KYC <span class="text-red-500">*</span>: </span>
                <SelectButton v-model="currentPaySys.kyc_required" :options="kycOptions" optionLabel="name" optionValue="value" aria-labelledby="kyc" />
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Время активности: </span>
                <div class="flex flex-column xl:flex-row lg:flex-row w-full gap-3">
                    <div class="flex flex-column w-full gap-2">
                        <span class="flex">С: </span>
                        <InputNumber v-model="currentPaySys.active_from" class="flex" :min="0" :max="24" :minFractionDigits="0" :maxFractionDigits="0" placeholder="0" :useGrouping="false" />
                    </div>
                    <div class="flex flex-column w-full gap-2">
                        <span class="flex">До: </span>
                        <InputNumber v-model="currentPaySys.active_to" class="flex" :min="0" :max="24" :minFractionDigits="0" :maxFractionDigits="0" placeholder="24" :useGrouping="false" />
                    </div>
                </div>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Таймеры (в мс): </span>
                <div class="flex flex-column xl:flex-row lg:flex-row w-full gap-3">
                    <div class="flex flex-column w-full gap-2">
                        <span class="flex">Истечение срока: </span>
                        <InputNumber v-model="currentPaySys.timers.expired" class="flex" :min="0" :max="999999999" placeholder="10000" :useGrouping="false" />
                    </div>
                    <div class="flex flex-column w-full gap-2">
                        <span class="flex">Обработка: </span>
                        <InputNumber v-model="currentPaySys.timers.process" class="flex" :min="0" :max="999999999" placeholder="20000" :useGrouping="false" />
                    </div>
                    <div class="flex flex-column w-full gap-2">
                        <span class="flex">Подтверждение: </span>
                        <InputNumber v-model="currentPaySys.timers.confirm" class="flex" :min="0" :max="999999999" placeholder="30000" :useGrouping="false" />
                    </div>
                </div>
            </div>

            <div class="flex flex-column xl:flex-row lg:flex-row w-full gap-3">
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Фиксированная комиссия: </span>
                    <InputNumber v-model="currentPaySys.comissions.fix" class="flex" :minFractionDigits="0" :maxFractionDigits="2" placeholder="0.00" />
                </div>
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Процентная комиссия: </span>
                    <InputNumber v-model="currentPaySys.comissions.percent" class="flex" :minFractionDigits="0" :maxFractionDigits="2" placeholder="0.00" />
                </div>
            </div>

            <div class="flex flex-column xl:flex-row lg:flex-row w-full gap-3">
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Минимальный лимит: </span>
                    <InputNumber v-model="currentPaySys.limits.min" class="flex" :minFractionDigits="0" :maxFractionDigits="2" placeholder="0.00" />
                </div>
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Максимальный лимит: </span>
                    <InputNumber v-model="currentPaySys.limits.max" class="flex" :minFractionDigits="0" :maxFractionDigits="2" placeholder="0.00" />
                </div>
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Изменить" @click='updPaySys()' :loading="loading" class="flex" :disabled="loading || !isEditFormValid"/>
                <Button label="Закрыть" icon="pi pi-times" @click="closeDialog" outlined class="flex" autofocus severity="secondary" :disabled="loading"/>
            </div>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { PaymentSystemList } from '@/assets/js/classes/PaymentSystem.js'
import { CurrencyList } from '@/assets/js/classes/Currency.js'

export default {
    data() {
        return {
            pays: [],
            currencies: [],
            lazyParams: {},
            filters: {
                direction: {value: null, matchMode: 'equals'},
                type: {value: null, matchMode: 'equals'},
                currency_code: {value: null, matchMode: 'equals'},
            },
            currentPaySys: {
                id: null,
                active: undefined,
                active_from: null,
                active_to: null,
                code: null,
                type: null,
                direction: null,
                currency_code: null,
                image: '/images/svg/pays/other.svg',
                titles: { ru: '', en: '' },
                descriptions: { ru: '', en: '' },
                sort: null,
                comissions: { percent: 0, fix: 0 },
                limits: { min: 0, max: 0 },
                recipient_fields: [],
                recipient_fields_required: [],
                kyc_required: undefined,
                timers: {
                    expired: null,
                    process: null,
                    confirm: null,
                }
            },
            totalRecords: 0,
            loading: false,
            editPopup: false,
            types: ['payment_system', 'merchant', 'internal'],
            fields: ['fullname', 'phone_number', 'card_number', 'account_number', 'wallet_address', 'wallet_network', 'telegram', 'bank_name', 'address', 'city', 'country', 'swift_code', 'iban_number', 'upi_id'],
            active_list: [
                { name: 'Активно', value: true },
                { name: 'Не активно', value: false }
            ],
            kycOptions: [
                { name: 'Требуется', value: true },
                { name: 'Не требуется', value: false }
            ],
            directions: [
                { label: 'Прием', value: 'get' },
                { label: 'Отправка', value: 'send' },
                { label: 'Прием/Отправка', value: 'both' }
            ],
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isEditFormValid() {
            return  this.currentPaySys.type && 
                    this.currentPaySys.code && 
                    this.currentPaySys.image &&
                    this.currentPaySys.titles.ru && this.currentPaySys.titles.en &&
                    this.currentPaySys.direction;
        },
    },
    methods: {
        onPage(event) {
            this.lazyParams = event
            // this.loadLazyData()
        },
        onSort(event) {
            this.lazyParams = event
            // this.loadLazyData()
        },
        onFilter() {
            this.lazyParams.filters = this.filters
            // this.loadLazyData()s
        },
        onRowSelect() {
            this.selectAll = this.selectedCustomers.length === this.totalRecords
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        get_title(value){
            return (value.titles && value.titles[this.lang_]) ? value.titles[this.lang_] : value.code
        },
        getDescription(value){
            return (value.descriptions && value.descriptions[this.lang_]) ? value.descriptions[this.lang_] : ''
        },
        get_image(value){
            return (value.image) ? value.image : '/images/svg/countries/unknown.svg'
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        edit(item){
            this.editPopup = true
            this.currentPaySys = {
                ...item,
                active_from: item.active_from ?? null,
                active_to: item.active_to ?? null,
            }
            if(!this.currentPaySys){
                this.showMess('warn', 'Внимание', 'Не найдена платежная система')
                return false
            }
        },
        getDataType(data){
            if(data.type=='merchant') return 'Мерчант';
            if(data.type=='payment_system') return 'Платежная система';
            if(data.type=='internal') return 'Внутренний';
            return data.type;
        },
        hasSchedule(data) {
            return data && data.active_from !== undefined && data.active_from !== null && data.active_to !== undefined && data.active_to !== null
        },
        getScheduleLabel(data) {
            if (!this.hasSchedule(data)) return '-'
            return this.getScheduleTime(data.active_from) + ' - ' + this.getScheduleTime(data.active_to) + ' GMT'
        },
        getScheduleTime(value) {
            return value.toString() + ':00'
        },
        getCurImage(code){
            return this.helper.GetCurrencyImage(code, this.currencies)
        },
        async LoadPays(){
            this.pays = await PaymentSystemList.FetchFromApi(this.$store).then(r=>r)
            console.log(this.pays)
        },
        async LoadCurrencies(){
            this.currencies = await CurrencyList.GetList(this.$store).then(r=>r)
        },
        closeDialog() {
            this.editPopup = false;
            this.currentPaySys = {
                active: undefined,
                active_from: null,
                active_to: null,
                code: null,
                type: null,
                direction: null,
                currency_code: null,
                image: '/images/svg/pays/other.svg',
                titles: { ru: '', en: '' },
                descriptions: { ru: '', en: '' },
                sort: null,
                kyc_required: undefined,
                timers: {
                    expired: null,
                    process: null,
                    confirm: null,
                },
            };
        },
        async updPaySys() {
            this.loading = true
            const data = {
                id: this.currentPaySys.id,
                active: this.currentPaySys.active,
                active_from: this.currentPaySys.active_from,
                active_to: this.currentPaySys.active_to,
                code: this.currentPaySys.code,
                type: this.currentPaySys.type,
                currency_code: this.currentPaySys.currency_code,
                image: this.currentPaySys.image,
                titles: this.currentPaySys.titles,
                descriptions: this.currentPaySys.descriptions,
                sort: this.currentPaySys.sort,
                recipient_fields: this.currentPaySys.recipient_fields,
                recipient_fields_required: this.currentPaySys.recipient_fields_required,
                kyc_required: this.currentPaySys.kyc_required,
                timers: this.currentPaySys.timers,
                comissions: this.currentPaySys.comissions,
                limits: this.currentPaySys.limits,
                direction: this.currentPaySys.direction,
            }
            try {
                const response = await this.connect.PaySysUpdateByAdmin(data).then(res => res)
                if (response.data) {
                    this.showMess('success', 'Успех', 'Платежная система успешно обновлена')
                    this.editPopup = false
                    await this.LoadPays().then()
                } else {
                    if(response.message){
                        this.showMess('error', 'Ошибка', response.message);
                    } else {
                        this.showMess('error', 'Ошибка', 'Произошла ошибка при обновлении')
                    }
                }
            } catch (error) {
                console.error(error)
                this.showMess('error', 'Ошибка', 'Произошла ошибка при обновлении')
            } finally {
                this.loading = false;
            }
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.lazyParams = {
            first: 0,
            // rows: dt.value.rows,
            rows: 10,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        await this.LoadPays().then()
        await this.LoadCurrencies().then()
    },
}
</script>